import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { isPrivateRoute } from "@/utils/seo";

/** Adds noindex to every private route (login, account, chat, admin, checkout). */
export const PrivateRouteRobots = () => {
  const { pathname } = useLocation();
  if (!isPrivateRoute(pathname)) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
    </Helmet>
  );
};
